import styled from "styled-components"
import { Icon } from "quorumdesign"
import { organizationPrimaryColor } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

export const Container = styled.div`
    display: flex;
    width: 40em;
    padding: 1em 0;
    flex-direction: column;
    align-items: center;
    gap: 3em;
    background: var(--plum-white, #fff);

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        padding: 1em 1em;
        gap: 2em;
    }
`

export const SvgWrapper = styled.div`
    width: 18.25em;
    height: 9.98513em;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 250px;
        height: auto;
    }
`

export const ActionCallTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--plum-spacing-xs, 0.5em);
    align-self: stretch;
`

export const StatusText = styled.div`
    align-self: stretch;
    color: var(--plum-gray-7, #495057);
    text-align: center;
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: 1.3125em; /* 150% */
`

export const ActionCallText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.75em;
`

export const ExclamationIconWrapper = styled.div`
    display: flex;
    width: var(--plum-font-xl, 1.5em);
    height: var(--plum-font-xl, 1.5em);
    justify-content: center;
    align-items: center;
`

export const ActionText = styled.div`
    color: var(--plum-black, #000);
    text-align: center;
    font-family: Roboto;
    font-size: 1.75em;
    font-style: normal;
    font-weight: 600;
    line-height: 2em; /* 114.286% */

    @media (max-width: 768px) {
        font-size: 1.5em;
        line-height: 1.75em;
    }
`

export const ExclamationStyledIcon = styled(Icon)`
    color: var(--plum-red-5, #e04345);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 1.5em;
    font-style: normal;
    font-weight: 900;
    line-height: 100%;
`

export const AddressWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--plum-spacing-xxs, 0.25em);
`

export const AddressIconWrapper = styled.div`
    display: flex;
    width: var(--plum-font-sm, 0.875em);
    height: var(--plum-font-sm, 0.875em);
    justify-content: center;
    align-items: center;
`

export const AddressStyledIcon = styled(Icon)`
    color: var(--plum-gray-5, #adb5bd);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 0.875em;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 0.875em */
`

export const AddressText = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: var(--plum-gray-7, #495057);
    text-align: center;
    font-feature-settings:
        "liga" off,
        "clig" off;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`

export const RegistrationOptions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--plum-spacing-xs, 0.5em);
    align-self: stretch;
`

export const RegistrationTextWrapper = styled.div`
    display: flex;
    padding: 0 4em;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
    align-self: stretch;

    @media (max-width: 768px) {
        padding: 0 1em;
    }
`

export const RegistrationText = styled.div`
    flex: 1 0 0;
    color: var(--plum-gray-7, #495057);
    text-align: center;
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: 1.3125em; /* 150% */
`

export const RegistrationLinks = styled.div`
    display: flex;
    padding-bottom: var(--plum-spacing-md, 1em);
    flex-direction: column;
    align-items: center;
    gap: 0.5em;
    align-self: stretch;
`

export const OnlineRegistration = styled.div`
    display: flex;
    width: 30em;
    height: 4em;
    max-width: 30em;
    min-height: 4em;
    padding: var(--plum-spacing-md, 1em) var(--plum-spacing-xxl, 2em);
    justify-content: space-between;
    align-items: center;
    border-radius: 2em;
    background: ${organizationPrimaryColor};
    text-decoration: none;
    color: inherit;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        padding: var(--plum-spacing-md, 1em) var(--plum-spacing-lg, 1.5em);
    }
`

export const OnlineRegistrationContent = styled.span`
    color: var(--plum-white, #fff);
    font-family: Roboto;
    font-size: 1em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`

export const OnlineRegistrationAnchor = styled.span`
    display: flex;
    width: var(--plum-font-md, 1em);
    height: var(--plum-font-md, 1em);
    justify-content: center;
    align-items: center;
`

export const StyledAnchor = styled(Icon)`
    color: var(--plum-white, #fff);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 1em;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 1em */
`

export const PaperRegistration = styled.div`
    display: flex;
    width: 30em;
    height: 4em;
    max-width: 30em;
    min-height: 4em;
    padding: 0 var(--plum-spacing-xxl, 2em);
    justify-content: space-between;
    align-items: center;
    border-radius: 2em;
    background: rgba(34, 61, 129, 0.1);
    position: relative;
    text-decoration: none;
    color: inherit;
    //font-size: 16px;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        padding: 0 var(--plum-spacing-lg, 1.5em);
    }
`

export const PaperRegistrationButton = styled(PaperRegistration)`
    cursor: pointer;
`

export const PaperRegistrationContent = styled.span`
    color: var(--plum-black, #000);
    font-family: Roboto;
    font-size: 1em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`

export const PaperRegistrationArrow = styled.span`
    display: flex;
    width: var(--plum-font-md, 1em);
    height: var(--plum-font-md, 1em);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
`

export const StyledDropdown = styled(Icon)`
    color: var(--plum-black, #000);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 1em;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 1em */
`

export const RegistrationStatusLink = styled.div`
    display: flex;
    padding: var(--plum-spacing-xs, 0.5em) var(--plum-spacing-md, 1em);
    align-items: center;
    gap: var(--plum-spacing-xs, 0.5em);
    border-radius: 2em;
    text-decoration: none;
    color: inherit;
`

export const RegistrationStatusLinkText = styled.div`
    color: var(--plum-black, #000);
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
`

export const StatusLinkAnchor = styled.span`
    display: flex;
    width: var(--plum-font-sm, 0.875em);
    height: var(--plum-font-sm, 0.875em);
    justify-content: center;
    align-items: center;
`

export const StyledLinkAnchor = styled(Icon)`
    color: var(--plum-black, #000);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`

export const PaperRegistrationDropdown = styled.div`
    display: flex;
    width: 30em;
    padding: 0.5em 0;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--plum-spacing-xxs, 0.25em);
    position: absolute;
    bottom: -6.375em;
    left: 0;
    border-radius: 0.5em;
    border: 1px solid var(--plum-gray-3, #dee2e6);
    background: var(--plum-white, #fff);
    /* Shadow/XL */
    box-shadow: 0 12px 40px -12px rgba(0, 0, 0, 0.2);

    @media (max-width: 768px) {
        width: 100%;
        left: 0;
        right: 0;
    }
`

export const PaperRegistrationDropdownOption = styled.div`
    display: flex;
    height: 2.5em;
    padding: var(--plum-spacing-sm, 0.75em) 1em;
    align-items: center;
    gap: 0.5em;
    align-self: stretch;
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:hover {
        background: var(--plum-gray-1, #f8f9fa);
    }
`

export const OptionFlag = styled.div`
    display: -webkit-box;
    max-width: 15em;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: var(--plum-white, #fff);
    font-feature-settings:
        "liga" off,
        "clig" off;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 0.875em */
`

export const OptionText = styled.div`
    display: -webkit-box;
    max-width: 15em;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: var(--plum-black, #000);
    font-feature-settings:
        "liga" off,
        "clig" off;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 0.875em */
`

export const FallbackText = styled(RegistrationText)`
    font-style: italic;
    color: var(--plum-gray-5, #808080);
`

export const OptionAnchor = styled.span`
    display: flex;
    width: var(--plum-font-sm, 0.875em);
    height: var(--plum-font-sm, 0.875em);
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 1em;
`

export const OptionStyledAnchor = styled(Icon)`
    color: var(--plum-black, #000);
    text-align: center;
    font-family: "Font Awesome 7 Pro";
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`
